import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { ContactUsComponent } from "./contact-us/contact-us.component";
import { ForumComponent } from "./forum/forum.component";
import { MarketplacePageComponent } from "./marketplace/marketplace.component";
import { MarketplaceShopDetailComponent } from "./marketplace/shop-detail/marketplace-shop-detail.component";
import { NewsComponent } from "./news/news.component";
import { SingleNewComponent } from "./news/single-new/single-new.component";
import { CustomersLayoutComponent } from "./layout/customers-layout/customers-layout.component";
import { CustomersLayoutReferralComponent } from "./layout/customers-layout-referral/customers-layout-referral.component";
import { RolesComponent } from "./community/roles/roles.component";
import { GiveawayComponent } from "./forum/giveaway/giveaway.component";
import { PollComponent } from "./forum/poll/poll.component";
import { TabForumComponent } from "./forum/tab-forum/tab-forum.component";
import { MemberPageComponent } from "./community/member-page/member-page.component";
import { CommunitySearchComponent } from "./community/community-search/community-search.component";
import { CommunityProfileComponent } from "./community/profile/profile.component";
import { SearchComponent } from "./community/search/search.component";
import { NewsMeComponent } from "./community/member-page/me/news-me/news-me.component";
import { ProfileMeComponent } from "./community/member-page/me/profile-me/profile-me.component";
import { AddMeComponent } from "./community/member-page/me/add-me/add-me.component";
import { NearbyproductsMeComponent } from "./community/member-page/me/nearbyproducts-me/nearbyproducts-me.component";
import { IndividualRentalComponent } from "./community/member-page/me/nearbyproducts-me/individual-rental/individual-rental.component";
import { IndividualAllProductComponent } from "./community/member-page/me/nearbyproducts-me/individual-all-product/individual-all-product.component";
import { IndividualFreeComponent } from "./community/member-page/me/nearbyproducts-me/individual-free/individual-free.component";
import { IndividualServicesComponent } from "./community/member-page/me/nearbyproducts-me/individual-services/individual-services.component";
import { IndividualEventsComponent } from "./community/member-page/me/nearbyproducts-me/individual-events/individual-events.component";
import { OtherCommuntyPageComponent } from "./community/other-communty-page/other-communty-page.component";
import { SellComponent } from "./community/other-communty-page/sell/sell.component";
import { BuyComponent } from "./community/other-communty-page/buy/buy.component";
import { ReferComponent } from "./community/other-communty-page/refer/refer.component";
import { WriteArticlesComponent } from "./community/other-communty-page/write-articles/write-articles.component";
import { ShopPageComponent } from "./shop-page/shop-page.component";
import { HowToEarnComponent } from "./community/other-communty-page/how-to-earn/how-to-earn.component";
import { TermsOfRentalComponent } from "./community/other-communty-page/terms-of-rental/terms-of-rental.component";
import { TermsOfServiceComponent } from "./community/other-communty-page/terms-of-service/terms-of-service.component";
import { CommunityRedirectGuard } from "./util/guard/community-redirect-guard/community-redirect.guard";
import { canDeactivateModalGuard } from "../shareModule/guard/can-deactivate-modal.guard";
import { AroundeMeComponent } from "./community/member-page/me/around-me/around-me.component";
import { AdvancedSettingsComponent } from "./advanced-settings/advanced-settings.component";
import { FaqComponent } from "./faq/faq.component";
import { AdvancedSettingsReferralComponent } from "./advanced-settings-referral/advanced-settings-referral.component";
import { IndividualProductsResolver } from "./community/member-page/member-page.resolver";
import { MarketplaceShopDetailResolver } from "./marketplace/shop-detail/marketplace-shop-detail.resolver";
import { MarketplaceResolver } from "./marketplace/marketplace.resolver";
import { PatchNoteComponent } from "./customer-footer/patch-note/patch-note.component";
import { MarketplaceProductComponent } from "./marketplace/marketplace-product/marketplace-product.component";
import { MarketplaceProductResolver } from "./marketplace/marketplace-product/marketplace-product.resolver";
import { RecommendPageComponent } from "./recommend-page/recommend-page.component";
import { HowItWorksComponent } from "./how-it-works/how-it-works.component";
import { BizLayoutComponent } from "./biz-layout/biz-layout.component";
import { SingleForumComponent } from "./forum/tab-forum/single-forum/single-forum.component";

const routes: Routes = [
  {
    path: "",
    component: CustomersLayoutComponent,
    children: [
      { path: "patch-Note", component: PatchNoteComponent },
      { path: "", component: CommunitySearchComponent },
      {
        path: "",
        component: OtherCommuntyPageComponent,
        children: [
          { path: "roles", component: RolesComponent },
          { path: "how-to-earn", component: HowToEarnComponent },
          { path: "policies", component: TermsOfServiceComponent },
          { path: "faq", component: FaqComponent },
          {
            path: "rental-system-terms-and-conditions",
            component: TermsOfRentalComponent,
          },
          { path: "buy", component: BuyComponent },
          { path: "sell", component: SellComponent },
          { path: "refer", component: ReferComponent },
          { path: "write-articles", component: WriteArticlesComponent },
        ],
      },
      {
        path: "community",
        children: [
          { path: "", component: CommunitySearchComponent, },

          { path: "profile/:code", component: CommunityProfileComponent },
          {
            path: "me",
            component: MemberPageComponent,
            canActivate: [CommunityRedirectGuard],
            children: [
              {
                path: "",
                component: NearbyproductsMeComponent,
                children: [
                  { path: "", component: IndividualAllProductComponent },
                  {
                    path: "nearby",
                    component: IndividualAllProductComponent,
                    resolve: {
                      individualProducts: IndividualProductsResolver,
                    },
                  },
                  {
                    path: "nearby/:slug",
                    component: IndividualAllProductComponent,
                    resolve: {
                      individualProducts: IndividualProductsResolver,
                    },
                  },
                  { path: "rental", component: IndividualRentalComponent },
                  { path: "free", component: IndividualFreeComponent },
                  { path: "events", component: IndividualEventsComponent },
                  { path: "services", component: IndividualServicesComponent },
                  { path: 'recommend', component: RecommendPageComponent }
                ],
              },
              { path: "around", component: AroundeMeComponent },
              { path: "profile", component: ProfileMeComponent },
              { path: "list", component: AddMeComponent },
              { path: "shout-out", component: NewsMeComponent },
              { path: ":base", component: CommunitySearchComponent },
              { path: ":base/:category", component: CommunitySearchComponent },
              { path: ":base/:category/:slug", component: CommunitySearchComponent },
            ],
          },
          {
            path: "category/:categoryName",
            component: SearchComponent,
          },
          {
            path: "category/:categoryName/:slug",
            component: SearchComponent,
          },
          {
            path: "category/:categoryName/:subCategoryName",
            component: SearchComponent,
          },
          {
            path: "category/:categoryName/:subCategoryName/:slug",
            component: SearchComponent,
          },
          {
            path: "rental/:categoryName",
            component: SearchComponent,
          },
          {
            path: "rental/:categoryName/:slug",
            component: SearchComponent,
          },
          {
            path: "rental/:categoryName/:subCategoryName",
            component: SearchComponent,
          },
          {
            path: "rental/:categoryName/:subCategoryName/:slug",
            component: SearchComponent,
          },
        ],
      },
      {
        path: "product",
        // component: MarketplaceProductComponent,

        children: [
          {
            path: ":product",
            component: MarketplaceProductComponent,
            // resolve: {
            //   MarketplaceProductResolver: MarketplaceProductResolver
            // },
          },
        ],
      },
      {
        path: "",
        children: [
          {
            path: "",
            component: ForumComponent,
            children: [
              { path: "forum", component: TabForumComponent },
              { path: "giveaway", component: GiveawayComponent },
              { path: "poll", component: PollComponent },
            ]
          },
          { path: "forum/:slug", component: SingleForumComponent },
          // { path: ":category", component: TabForumComponent },
          // { path: ":category/:uuid", component: TabForumComponent },
        ],
      },
      // { path: "chat", component: ChatPageComponent },
      {
        path: "shop-page",
        component: ShopPageComponent,
        canActivate: [CommunityRedirectGuard],
      },
      {
        path: "advanced-settings",
        component: AdvancedSettingsComponent,
        canActivate: [CommunityRedirectGuard],
      },
      {
        path: "biz",
        canDeactivate: [canDeactivateModalGuard],
        resolve: {
          MarketplaceResolver: MarketplaceResolver
        },
        children: [
          {
            path: "",
            component: BizLayoutComponent,
            children: [
              {
                path: "",
                component: MarketplacePageComponent,
              },
              {
                path: "how-it-works",
                component: HowItWorksComponent,
              },
            ],
          },
          {
            path: "shop/:shop",
            component: MarketplaceShopDetailComponent,
            resolve: { MarketplaceShopDetail: MarketplaceShopDetailResolver },
          },
          {
            path: "category/:category",
            component: MarketplacePageComponent,
          },
          {
            path: "category/:category/:slug",
            component: MarketplacePageComponent,
          },
          {
            path: ":slug",
            component: MarketplacePageComponent,
          },
        ],
      },
      {
        path: "news",
        component: NewsComponent,
      },
      { path: "news/:slug", component: SingleNewComponent },
      { path: "privacy", component: PrivacyPolicyComponent },
      { path: "contact-us", component: ContactUsComponent },
      {
        path: "",
        children: [
          //search Page route
          {
            path: "category/:categoryName",
            component: SearchComponent,
          },
          {
            path: "category/:categoryName/:slug",
            component: SearchComponent,
          },
          {
            path: "category/:categoryName/:subCategoryName",
            component: SearchComponent,
          },
          {
            path: "category/:categoryName/:subCategoryName/:slug",
            component: SearchComponent,
          },
          {
            path: "rental/:categoryName",
            component: SearchComponent,
          },
          {
            path: "rental/:categoryName/:slug",
            component: SearchComponent,
          },
          {
            path: "rental/:categoryName/:subCategoryName",
            component: SearchComponent,
          },
          {
            path: "rental/:categoryName/:subCategoryName/:slug",
            component: SearchComponent,
          },
          { path: ":base", component: CommunitySearchComponent },
          { path: ":base/:category", component: CommunitySearchComponent },
          { path: ":base/:category/:slug", component: CommunitySearchComponent },
          //search Page route
        ]
      },
      { path: "", redirectTo: "/community", pathMatch: "full" },
    ],
  },
  {
    path: "profile/:code",
    component: CustomersLayoutComponent,
    children: [
      {
        path: "",
        component: CommunityProfileComponent,
      },
    ],
  },
  {
    path: "brand",
    component: CustomersLayoutReferralComponent,
    children: [
      { path: "", component: MarketplaceShopDetailComponent },
      { path: "settings", component: AdvancedSettingsReferralComponent },
    ],
  },
  {
    path: "share/:shop",
    component: CustomersLayoutReferralComponent,
    children: [
      {
        path: "", component: MarketplaceShopDetailComponent,
        resolve: { MarketplaceShopDetail: MarketplaceShopDetailResolver }
      },
      { path: "settings", component: AdvancedSettingsReferralComponent },
    ],
  },


  { path: "**", redirectTo: "/" },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomersRoutingModule { }
